import { Pipe, PipeTransform, Inject } from '@angular/core';
import { AuthUrlService } from '../services/auth-url.service';
import { ENVIRONMENT } from 'shared';

@Pipe({
  name: 'serverAuthUrl',
  standalone: true,
})
export class ServerAuthUrlPipe implements PipeTransform {
  constructor(private authUrlService: AuthUrlService, 
              @Inject(ENVIRONMENT) private environment: any) {}

  transform(path: string): string {
    if (!path) return '';
    // only process paths that start with '/' (root-relative internal paths)
    // for all other cases (https://, http://, //, relative, etc.) — return as-is
    if (path.startsWith('/')) {
      const serverUrl = this.environment.serverUrl.replace(/\/$/, '');
      const cleanPath = path.slice(1); // Remove the leading '/'
      const url = `${serverUrl}/${cleanPath}`;
      return this.authUrlService.rewrite(url);
    }
    return path;
  }
}